import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";

const Changelang = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <Typography.Text className="lang-switch" strong onClick={toggleLanguage}>
      {i18n.language === "en" ? "AR" : "EN"}
    </Typography.Text>
  );
};

export default Changelang;
